export default __webpack_public_path__ + "locales/sl/Files.json?hash=a4c732918c56fa1f85ae101c4934297a";